export default "__VITE_ASSET__CwH4zzqZ__"